import { CgNotes } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { FaPlus } from "react-icons/fa6";
import dayjs from "dayjs";
import { MdOutlineDeleteOutline } from "react-icons/md";
import UpdateNotes from "./UpdateNotes";
import { noteServices } from "../../../APIServices/SitePilotManagement/noteServices";
import React, { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { BsSortUp } from "react-icons/bs";
import AddNotes from "./AddNotes";
import { Collapse } from "react-bootstrap";
import TimelineNoteHistory from "./TimelineNoteHistory";
import UseToggle from "../../../Hooks/UseToggle";
import { VscHistory } from "react-icons/vsc";

const ContactNotes = ({ contactId, currentUserData }) => {
  const toggles = UseToggle();
  const [action, setAction] = useState("");
  const [loader, setLoader] = useState(false);
  const [notes, setNotes] = useState([]);
  const [noteData, setNoteData] = useState("");

  const buildNoteList = (notes) => {
    return notes.map((item) => {
      const date = dayjs(item.createdAt);
      return {
        noteId: item.noteId,
        contactId: item.contactId,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        note: item.note,
        createdByName: item.createdByName,
      };
    });
  };

  const getNoteList = async () => {
    setLoader(true);
    let data = await noteServices.getNoteList(
      contactId,
    );
    setNotes(buildNoteList(data?.data || []));
    setLoader(false);
  };

  const deleteNote = async (noteId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this note?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.noteId = noteId
        let data = await noteServices.deleteNote(userData)
        if (data?.statusCode === 200) {
          getNoteList()
        }
      }
    });
  };

  useEffect(() => {
    if (contactId) {
      getNoteList();
    }
  }, [contactId]);
  return (
    <>
      <div className="preview-block">
        {notes?.length > 0 ?
          <div className="timeline-wrapper">
            <div className="timeline-header">
              <div className="hstack justify-content-between w-100">
                <div className="preview-switcher p-0" style={{ zIndex: 1 }}>
                  <button
                    className="timeline-btn border px-2"
                    onClick={() => setAction(action === "add" ? "" : "add")}
                  >
                    <FaPlus size={12} />
                    <span>Add New Note</span>
                  </button>
                </div>
                <button className="timeline-btn border px-2">
                  <span>Created on</span>
                  <BsSortUp size={12} />
                </button>
              </div>
            </div>
            <Collapse in={action === "add"}>
              <div>
                <AddNotes
                  setAction={setAction}
                  getNoteList={getNoteList}
                  contactId={contactId}
                />
              </div>
            </Collapse>
            {notes.map((item, index) => (
              <React.Fragment key={index}>
                {index === 0 && (
                  <div className="timeline-date">{item.dateGroup}</div>
                )}
                <div className="timeline-item">
                  <div className="timeline-icon note">
                    <CgNotes />
                  </div>
                  <div className="timeline-card">
                    <div className="timeline-card-header">
                      <strong>Note</strong>
                      <span>Created by : {item.createdByName}</span>
                      <time>{item.time}</time>
                    </div>
                    {(action === "update" && noteData?.noteId === item?.noteId) ?
                      <UpdateNotes
                        setAction={setAction}
                        title={`Update Note`}
                        getNoteList={getNoteList}
                        contactId={contactId}
                        noteData={noteData}
                        setNoteData={setNoteData}
                      />
                      :
                      <>
                        <p className="timeline-text">{item.note}</p>
                        <button
                          className="timeline-action"
                          title="Edit Note"
                          style={{ right: 70 }}
                          onClick={() => { setAction("update"); setNoteData(item) }}
                        >
                          <CiEdit />
                        </button>
                        <button
                          className="timeline-action"
                          style={{ right: 40 }}
                          title="Changelogs"
                          onClick={() => { setNoteData(item); toggles.setToggle1() }}
                        >
                          <VscHistory />
                        </button>
                        <button
                          className="timeline-action text-danger"
                          title="Delete Note"
                          onClick={() => deleteNote(item.noteId)}
                        >
                          <MdOutlineDeleteOutline />
                        </button>
                      </>
                    }
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
          :
          <AddNotes
            setAction={setAction}
            getNoteList={getNoteList}
            contactId={contactId}
          />
        }
      </div>
      <TimelineNoteHistory
        show={!toggles.toggle1}
        hide={toggles.setToggle1}
        title={"Changelogs"}
        contactId={noteData?.contactId}
        inboxId={noteData?.inboxId}
        uniqueId={noteData?.noteId}
        propertyId={currentUserData?.loginPropertyId}
      />
    </>
  );
};

export default ContactNotes;
